import React, { Component } from 'react';
import NewDevisForm from './NewDevisForm';
import { getList, getClientInfoList } from '../../../../../../jsx/actions/devisAction';
import { getProspectList } from '../../../../../../jsx/actions/prospectAction';
import { fetchInstallers } from '../../../../../../jsx/actions/paygAction';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DevisActionForm from './DevisActionForm';
import PaygPopupInfo from '../paygPopupInfo';
import { isEmpty } from "lodash"
import NewFormRegestering from '../module/NewFormRegestering';
import { Table, TableHead, TableBody, TableRow, TableCell, Button, Card, Box, AppBar, Tabs, Tab } from '@material-ui/core';
import { DirectionsWalkRounded, EditRounded, CheckRounded, AssignmentRounded, Build, PostAddRounded ,AddRounded,CommentRounded} from '@material-ui/icons';
import { TableLayout } from '../Stock/containers/Layout';
import CardPage from '../../../commonModules/layouts/CardPage';
import Spin from '../../../commonModules/interface/Spin';
import { InputSelectMagasin } from '../../../commonModules/interface/form-input-inline';

class Devis extends Component {
    state = { 
        headerMenu: "PLAN_VISIT",
        openNewQuotation: false,
        showPopUpInfo: false,
        openActionDialog: false,
        currentClient:"",
        client: {},
        schemasList: [],    
    }

    componentWillMount = () => {
        // await this.props.getProspectList()
        // this.props.getList("PLAN_VISIT")
        Promise.all([
            this.fetchProspects(),
            this.onChangeTab("PLAN_VISIT"),
        ])
        if( !this.props.INSTALLERS){
            this.props.fetchInstallers()
        }
    }
    // componentWillUpdate = (nextPro) => {

    // }
    fetchProspects = async () => {
        const { PROSPECTS } = this.props;
        
        if( isEmpty(PROSPECTS) ){
            await this.props.getProspectList()
        }
        
    }
    onChangeTab = async (headerMenu) => {
        const { CLIENTS } = this.props;
        if( CLIENTS[headerMenu].length === 0 ){
            await this.props.getList(headerMenu)
        }
        this.setState({headerMenu})
    }
    createProspectList = () => {
        const { PROSPECTS, CLIENTS } = this.props;
        const { headerMenu, selectedClient} = this.state;

        let clientList = CLIENTS[headerMenu]
        let list = []
        
        clientList.length > 0 && clientList.map( ID => {
            let client = PROSPECTS[ID]
            // console.log("create list", {client, ID, PROSPECTS });    
            
            if((client && !selectedClient) || (client && selectedClient === ID)){
                list.push(

                    <TableRow key={client.ID} hover >
                        {/* <TableCell onClick={ () => this.setState({showPopUpInfo: true, currentClient: client.ID,})}>{client.ID}</TableCell> */}
                        <TableCell onClick={ () => this.setState({showPopUpInfo: true, currentClient: client.ID, client})}>{client.Nom} {client.Prénom}</TableCell>
                        <TableCell onClick={ () => this.setState({showPopUpInfo: true, currentClient: client.ID, client})}>{client.Localisation && client.Localisation[0]}</TableCell>
                        <TableCell onClick={ () => this.setState({showPopUpInfo: true, currentClient: client.ID, client})}>{client.Téléphone}</TableCell>
                        <TableCell>
                            {headerMenu === "WAITING_QUOTATION" &&
                                <Button color="secondary" title="Créer un devis" onClick={()=>this.setState({currentClient: client.ID, client, openNewQuotation : true})}>
                                    {/* <i className="zmdi zmdi-file-plus"></i> */}
                                    <PostAddRounded />
                                </Button>
                            }
                            <Button color="secondary" title="Nouvelle action" onClick={()=>this.setState({currentClient: client.ID, client, openActionDialog : true})}>
                                {headerMenu === "PLAN_VISIT" &&
                                    // <i className="zmdi zmdi-walk"></i>
                                    <DirectionsWalkRounded />
                                }
                                {headerMenu === "WAITING_VISIT" &&
                                    // <i className="zmdi zmdi-edit"></i>
                                    <EditRounded />
                                }
                                {headerMenu === "WAITING_QUOTATION" &&
                                    // <i className="zmdi zmdi-plus"></i>
                                    <AddRounded />
                                }
                                {headerMenu === "WAITING_VALIDATION" &&
                                    // <i className="zmdi zmdi-check"></i>
                                    <CheckRounded />
                                }
                                {headerMenu === "WAITING_ANSWER" &&
                                    // <i className="zmdi zmdi-assignment-check"></i>
                                    <AssignmentRounded />
                                }
                                {headerMenu === "VALIDATE" &&
                                    // <i className="zmdi zmdi-wrench"></i>
                                    <Build />
                                }
                                {headerMenu === "REFUSED" &&
                                    // <i className="zmdi zmdi-walk"></i>
                                    <DirectionsWalkRounded />
                                }
                                {headerMenu === "INSTALLED" &&
                                    // <i className="zmdi zmdi-comment-text-alt"></i>
                                    <CommentRounded />
                                }
                            </Button>
                        </TableCell>
                    </TableRow>
                )
            }
        })
        return list
        
    }
    handleClose = () => {
        this.setState({
            openNewQuotation: false,
            openActionDialog: false,
            currentClient:"",
            client: {},
        })
    }
    getQuotationSchemas= async () =>{
        try {
            const response = await fetch("/schema/quotation/list", {
                method: 'GET',
                headers: {
                   'Content-Type': 'application/json',
                   // 'X-Requested-With': 'XMLHttpRequest',
                   //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
                });            
                const resp = await response.json();
                console.log(resp);
                this.setState({ schemasList: resp.content ? resp.content : [] });
        } catch (error) {
            console.log("[ERROR] GET TECH SCHEMAS LIST ", error);
            
        }
    }
    notif = (type, msg, title = "") =>{
        this.setState({
            notif: {
                title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    handleChange = (e, headerMenu) => {
        console.log("CHANGE HEADER MENU TO :",headerMenu)
        this.onChangeTab(headerMenu)
        this.setState({
            headerMenu
        })
    }
    render() {
        const { headerMenu, openNewQuotation, openActionDialog, currentClient, client, showPopUpInfo, showPopUpSchema } = this.state;
        const { PROSPECTS, CLIENTS} = this.props;

        console.log('========= RENDER =======');
        console.log("[PROPS]", this.props);
        console.log('========================');
        
        let boxList = [{value:"", label:"Tous"}]

        CLIENTS[headerMenu].map( ID => {
            let client = PROSPECTS[ID]
            if(client){
                boxList.push({value:ID, label:`${client.Nom} ${client.Prénom} - ${ID}`})
            }
        })
        // console.log("[DEBUG] ===>", CLIENTS[headerMenu]);

        return (
            <CardPage
                title="Liste des Devis"
            >
         
                {(openActionDialog && currentClient) &&
                    <DevisActionForm 
                        title={`Nouvelle action pour ${client.Nom} ${client.Prénom}`}
                        close={this.handleClose}
                        clientID={currentClient} 
                        status={ headerMenu } 
                        handleClose={()=> this.setState({openActionDialog: false})} 
                        openNewSchema={ ()=> this.setState({showPopUpSchema: true}) }  
                        schemasList={ this.state.schemasList }  
                        fetchSchemas={() => this.getQuotationSchemas()}
                        notif={this.props.notif}
                    />
                }

                {(showPopUpInfo && currentClient) &&
                
                    <PaygPopupInfo 
                        userID={currentClient}
                        boxAssoId={currentClient}
                        clientInfo={this.state.client}
                        closePopup={()=>this.setState({ showPopUpInfo: false})}
                        USER_INFO_LIST = {["PROSPECT"]}
                        QUOTATION_INFO_LIST
                        NO_DASHBOARD
                        default_tab = {"SUIVI DEVIS"}
                        prospect
                        // infos={this.props.getClientInfoList}
                    />
                }

                {showPopUpSchema && 
                    <NewFormRegestering 
                        popupState={true}
                        onCloseOverlay={ () => this.setState({showPopUpSchema: false})} 
                        quotation
                        fetchSchemas={() => this.getQuotationSchemas()}
                    />
                }
                
                {currentClient && openNewQuotation ? (
                    <NewDevisForm handleClose={()=> this.setState({openNewQuotation: false})} client={this.state.client} clientID={currentClient} notif={this.props.notif}/>
                ) : (
                    <Card>
                        <Box p={1}>
                            <InputSelectMagasin
                                options={boxList}
                                value={this.state.selectedClientDisplay}
                                placeholder="Choisissez un Prospect"
                                label="Prospect"
                                onChange={(option) => this.setState({ selectedClient: option.value, selectedClientDisplay:option }) }
                                // onChange={(option) => this.setState({ selectedClient: option.value, selectedClientDisplay:option }, this.filter) }
                                // style={{border: '0'}}
                                // selectedValue={this.state.selectedClientDisplay}
                            />
                        </Box>
                        <AppBar position="static">
                            <Tabs
                                value={headerMenu}
                                onChange={this.handleChange}
                                indicatorColor="secondary"
                                // textColor="secondary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab value="PLAN_VISIT" label="Client en Attente" />
                                <Tab value="WAITING_VISIT" label="En Attente de Visite" />
                                <Tab value="WAITING_QUOTATION" label="En Attente de Devis" />
                                <Tab value="WAITING_VALIDATION" label="En Cours" />
                                <Tab value="WAITING_ANSWER" label="En Attente de Réponse" />
                                <Tab value="VALIDATE" label="Validé" />
                                <Tab value="REFUSED" label="Refusé" />
                                <Tab value="INSTALLED" label="Installé" />
                            </Tabs>
                        </AppBar>
                        <Box p={2}>
                            {this.props.STATE.devis.fetching ?
                                <Spin noOverlay />
                            :
                                <TableLayout>
                                    <TableHead>
                                        <TableRow>
                                            {/* <TableCell component="th">ID</TableCell> */}
                                            <TableCell component="th">Nom</TableCell>
                                            <TableCell component="th">Localité</TableCell>
                                            <TableCell component="th">Tel</TableCell>
                                            <TableCell component="th">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>    
                                        {(!isEmpty(PROSPECTS) && !isEmpty(CLIENTS[headerMenu])) &&   
                                            this.createProspectList()
                                        }
                                    </TableBody>
                                </TableLayout>
                            }                                
                        </Box>
                    </Card>                       
                )}
            </CardPage>
        );
    }
}

function mapStateToProps(state){
    return {
        PROSPECTS: state.prospects.RESUME, // .RESUME not working 
        CLIENTS: state.devis,
        INSTALLERS: state.installers,
        STATE: state.inventory.requestState,

    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getList,
        getClientInfoList,
        getProspectList,
        fetchInstallers
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Devis);